import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography, styled, alpha } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ListBox } from '../Listbox/ListBox.js';
import { CommonWrapper } from './CommonWrapper.js';
import { CLASSES, BREADCRUMBS_CONSTANTS } from './constants/index.js';

const BreadcrumbsDots = forwardRef(function BreadcrumbsDots({ children, "data-testid": dataTestId, isDropdownVisible, onClick }, ref) {
    return (jsxs(Wrapper, { ref: ref, children: [jsx(CommonWrapper, { className: CLASSES.isDropdown, children: jsx(Dots, { "data-testid": dataTestId, onClick: onClick, children: jsx(Typography, { fontSize: 12, fontWeight: 500, sx: { paddingLeft: 0, textTransform: "uppercase" }, children: BREADCRUMBS_CONSTANTS.ELLIPSIS }) }) }), jsx(StyledListBox, { className: clsx({ hidden: !isDropdownVisible }), children: children })] }));
});
const Wrapper = styled("div")({ position: "relative", display: "flex" });
const Dots = styled("span")(({ theme }) => ({
    borderRadius: 4,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 1,
    padding: theme.spacing(0.5),
    textDecoration: "none",
    textTransform: "uppercase",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    margin: 0,
    height: "max-content",
    "&:hover": {
        textDecorationLine: "none",
        backgroundColor: theme.palette.primary[50],
    },
    "&:active": {
        backgroundColor: alpha(theme.palette.primary.main, 0.15),
    },
}));
const StyledListBox = styled(ListBox)({
    width: BREADCRUMBS_CONSTANTS.DROPDOWN_MENU_WIDTH,
    top: "100%",
    "> li:not(.link):hover": {
        cursor: "default",
        backgroundColor: "transparent",
    },
});

export { BreadcrumbsDots };
//# sourceMappingURL=BreadcrumbsDots.js.map
